var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-bar" },
    [
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Role")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.roleCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("group", $event)
              }
            },
            model: {
              value: _vm.role,
              callback: function($$v) {
                _vm.role = $$v
              },
              expression: "role"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Work Location")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.workLocationCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("workLocation", $event)
              }
            },
            model: {
              value: _vm.workLocation,
              callback: function($$v) {
                _vm.workLocation = $$v
              },
              expression: "workLocation"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Project Allocation")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.projectAllocationCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("projectAllocation", $event)
              }
            },
            model: {
              value: _vm.projectAllocation,
              callback: function($$v) {
                _vm.projectAllocation = $$v
              },
              expression: "projectAllocation"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Side Hustle")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.sideHustleCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("sideHustle", $event)
              }
            },
            model: {
              value: _vm.sideHustle,
              callback: function($$v) {
                _vm.sideHustle = $$v
              },
              expression: "sideHustle"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Employment Type")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.employmentTypeCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("status", $event)
              }
            },
            model: {
              value: _vm.employmentType,
              callback: function($$v) {
                _vm.employmentType = $$v
              },
              expression: "employmentType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-checkbox", {
        staticClass: "filter-item-checkbox",
        attrs: { label: "Show Inactive" },
        on: {
          change: function($event) {
            return _vm.onChangeInactive()
          }
        },
        model: {
          value: _vm.showInactive,
          callback: function($$v) {
            _vm.showInactive = $$v
          },
          expression: "showInactive"
        }
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "primary--text spacing",
          attrs: { outlined: "" },
          on: { click: _vm.clearFilters }
        },
        [_vm._v("Clear Filters")]
      ),
      _vm._v(" "),
      _c("add-person")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e395e08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e395e08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/PeopleFilters.vue
// module id = BE4E
// module chunks = 1